import React from 'react';
import style from './GaugeChart.module.css'; // 게이지 전용 CSS 쓰면 분리, 지금은 .gauge만 사용

const SEGMENTS = [
    { startDeg: 0,   endDeg: 60,  color: '#3284FF' },
    { startDeg: 60,  endDeg: 120, color: '#FF8D29' },
    { startDeg: 120, endDeg: 180, color: '#E55151' },
];
const DIVIDERS = [60, 120];

const GaugeChart = ({ angle, animate, size = 220, cy = 130, outerR = 95, innerR = 50, dividerWidth = 6 }) => {
    const cx = size / 2;

    const degToRad = (deg) => ((180 + deg) * Math.PI) / 180;

    const wedgePath = (startDeg, endDeg, inner, outer) => {
        const s = degToRad(startDeg);
        const e = degToRad(endDeg);
        const large = (endDeg - startDeg) > 180 ? 1 : 0;
        const ox1 = cx + outer * Math.cos(s);
        const oy1 = cy + outer * Math.sin(s);
        const ox2 = cx + outer * Math.cos(e);
        const oy2 = cy + outer * Math.sin(e);
        const ix1 = cx + inner * Math.cos(e);
        const iy1 = cy + inner * Math.sin(e);
        const ix2 = cx + inner * Math.cos(s);
        const iy2 = cy + inner * Math.sin(s);
        return `M ${ox1} ${oy1} A ${outer} ${outer} 0 ${large} 1 ${ox2} ${oy2} L ${ix1} ${iy1} A ${inner} ${inner} 0 ${large} 0 ${ix2} ${iy2} Z`;
    };

    const needleAngle = animate ? angle : 0;

    return (
        <svg width={size} height={cy + 16} viewBox={`0 0 ${size} ${cy + 16}`} className={style.gauge}>
            {SEGMENTS.map((seg, i) => (
                <path key={i} d={wedgePath(seg.startDeg, seg.endDeg, innerR, outerR)} fill={seg.color} />
            ))}

            {DIVIDERS.map((deg, i) => {
                const rad = degToRad(deg);
                const x1 = cx + (innerR - 4) * Math.cos(rad);
                const y1 = cy + (innerR - 4) * Math.sin(rad);
                const x2 = cx + (outerR + 4) * Math.cos(rad);
                const y2 = cy + (outerR + 4) * Math.sin(rad);
                return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#fff" strokeWidth={dividerWidth} />;
            })}

            <g style={{
                transform: `rotate(${needleAngle - 90}deg)`,
                transformOrigin: `${cx}px ${cy}px`,
                transition: animate ? 'transform 1.2s cubic-bezier(0.34, 1.56, 0.64, 1)' : 'none',
            }}>
                <polygon points={`${cx},${cy - 72}, ${cx - 5},${cy}, ${cx + 5},${cy}`} fill="#2D2D2D" />
                <polygon points={`${cx - 3.5},${cy}, ${cx + 3.5},${cy}, ${cx},${cy + 10}`} fill="#2D2D2D" />
            </g>

            <circle cx={cx} cy={cy} r="8" fill="#2D2D2D" />
            <circle cx={cx} cy={cy} r="3.5" fill="#555" />
        </svg>
    );
};

export default React.memo(GaugeChart);


 